import React from 'react';

export default function AdminImagesSection() {
  const imageSources = [
    {
      name: 'Pixabay',
      url: 'https://pixabay.com/',
      description: 'Free images and royalty-free stock photos. Great for finding high-quality images for your app.',
      icon: '🖼️'
    }
  ];

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <span>🖼️</span>
          <span>Images</span>
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Find images to use in your app from these recommended sources
        </p>
      </div>

      <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-xs text-blue-900">
          <span className="font-semibold">Tip:</span> Download images from these sources, then upload them to your app's CDN folder to use them in your app.
        </p>
      </div>

      <div className="space-y-3">
        {imageSources.map(({ name, url, description, icon }) => (
          <div
            key={name}
            className="flex items-start justify-between gap-4 p-4 bg-gray-50 border border-gray-200 rounded-lg hover:bg-gray-100 transition-colors group"
          >
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 mb-1 flex items-center gap-2">
                <span>{icon}</span>
                <span>{name}</span>
              </p>
              <p className="text-xs text-gray-500 mb-2">{description}</p>
              <code className="text-sm text-gray-800 font-mono bg-white px-2 py-1 rounded border border-gray-300 block break-all">
                {url}
              </code>
            </div>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="ml-4 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 text-sm font-medium whitespace-nowrap transition-colors flex items-center gap-2 flex-shrink-0"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
              <span>Visit</span>
            </a>
          </div>
        ))}
      </div>

      <div className="mt-4 p-3 bg-gray-50 border border-gray-200 rounded-lg">
        <p className="text-xs text-gray-600">
          <span className="font-semibold">Note:</span> Always check the license terms for each image you download. Most images from these sources are free for commercial use, but some may require attribution.
        </p>
      </div>
    </div>
  );
}
